module.exports = __webpack_public_path__ + "static/media/sharan.04ae220b.png";